import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './RichHtmlEditor.css';

const defaultModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    ['blockquote'],
    ['link'],
    ['clean'],
  ],
};

const defaultFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'indent',
  'align',
  'blockquote',
  'link',
];

/**
 * Rich text editor that reads/writes HTML strings (for CMS-style settings fields).
 */
export default function RichHtmlEditor({
  id,
  value,
  onChange,
  minHeight = 200,
  placeholder,
  className = '',
  'aria-label': ariaLabel,
}) {
  const modules = useMemo(() => defaultModules, []);

  return (
    <div className={`rich-html-editor ${className}`.trim()} style={{ minHeight }} id={id}>
      <ReactQuill
        theme='snow'
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={defaultFormats}
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
    </div>
  );
}
